import { render } from "./SliderPaywall.vue?vue&type=template&id=7ff2dcac&scoped=true"
import script from "./SliderPaywall.vue?vue&type=script&setup=true&lang=js"
export * from "./SliderPaywall.vue?vue&type=script&setup=true&lang=js"

import "@vueform/slider/themes/default.css?vue&type=style&index=0&lang=css"
import "./SliderPaywall.vue?vue&type=style&index=1&id=7ff2dcac&lang=css"
import "./SliderPaywall.vue?vue&type=style&index=2&id=7ff2dcac&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ff2dcac"],['__file',"src/views/paywall/SliderPaywall.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7ff2dcac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7ff2dcac', __exports__)) {
    console.log('reload')
    api.reload('7ff2dcac', __exports__)
  }
  
  module.hot.accept("./SliderPaywall.vue?vue&type=template&id=7ff2dcac&scoped=true", () => {
    console.log('re-render')
    api.rerender('7ff2dcac', render)
  })

}


export default __exports__